import { render, staticRenderFns } from "./supportPlanModal.vue?vue&type=template&id=54b98f88&scoped=true"
import script from "./supportPlanModal.vue?vue&type=script&lang=js"
export * from "./supportPlanModal.vue?vue&type=script&lang=js"
import style0 from "./supportPlanModal.vue?vue&type=style&index=0&id=54b98f88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b98f88",
  null
  
)

export default component.exports